import { render, staticRenderFns } from "./UsuarioLab.vue?vue&type=template&id=21c12ff6&scoped=true"
import script from "./UsuarioLab.vue?vue&type=script&lang=js"
export * from "./UsuarioLab.vue?vue&type=script&lang=js"
import style0 from "./UsuarioLab.vue?vue&type=style&index=0&id=21c12ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c12ff6",
  null
  
)

export default component.exports